module.exports = __webpack_public_path__ + "static/media/blog_img9.e873531f.jpg";